import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const ReviewQualityListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  ${mediaQuery.xs} {
    flex-wrap: wrap;
  }
`;

export const ReviewQualityListItemWrapper = styled.div<{
  isLoading?: boolean;
}>`
  flex: 0 1 calc(50% - 20px);
  margin: 10px;
  height: 125px;
  border: 1px solid #ced4da;
  border-radius: 15px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  padding: 8px 0px;
  color: #737373;
  background-color: #f8f9fa;

  ${({ isLoading }) =>
    isLoading &&
    `
    padding: 0px;
  `}

  ${mediaQuery.xs} {
    flex: 0 1 45%;
    margin-bottom: 25px;
    height: 115px;

    &:nth-child(5) {
      margin: auto;
    }
  }
`;

export const ReviewQualityListItemHeader = styled.span`
  font-size: 16px;
  margin-bottom: 5px;
  font-weight: 400;

  span {
    margin-left: 5px;
  }

  ${mediaQuery.xs} {
    font-size: 16px;
  }
`;

export const ReviewQualityListItemValue = styled.span<{
  color: string;
}>`
  font-size: 35px;
  font-weight: 400;
  color: ${({ color }) => color};

  ${mediaQuery.xs} {
    font-size: 24px;
  }
`;
